import React from 'react';
import ScrollspyNav from "react-scrollspy-nav";
import { Container, Nav } from 'react-bootstrap';
import ScrollspyNavItemHome from "../layout/ScrollspyNavItemHome";
import SubNavigationTeaserButton from "../layout/SubNavigationTeaserButton";

import InfosDownloads from "../sections/InfosDownloads";
import RbsPage from '../controls/RbsPage';
import Firmen2026 from '../sections/2026/Firmen2026';
import FaqSection from '../sections/Faq_Section';
import Programm2026 from '../sections/2026/Programm2026';
import Redaktionen2026 from '../sections/2026/Redaktionen2026';
// import Bilder from '../sections/Bilder';

const Fachpressetage2026 = (props) => {

  return (
    <RbsPage>

      <nav className="navbar sticky-md-top subnav">
        <Container>
          <ScrollspyNav scrollTargetIds={[
            "Programm",
            "Firmenteilnehmer",
            //"Redaktionen",
            "InfosDownloads",
            //"Firmenbesuch",
            "Faq"
          ]} offset={0} activeNavClass="active" scrollDuration="10" headerBackground="true">
            <Nav variant="pills">
              <ScrollspyNavItemHome />
              <Nav.Item>
                <Nav.Link href="#Programm">Programm</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Firmenteilnehmer">Firmenteilnehmer</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Redaktionen">Redaktionen</Nav.Link>
              </Nav.Item>
              {/* 
              <Nav.Item>
                <Nav.Link href="#Firmenbesuch">Firmenbesuch</Nav.Link>
              </Nav.Item>
*/}
              <Nav.Item>
                <Nav.Link href="#InfosDownloads">Infos &amp; Downloads</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#Faq">FAQ</Nav.Link>
              </Nav.Item>
            </Nav>
          </ScrollspyNav>
        </Container>
        <SubNavigationTeaserButton />
      </nav>


      {/* <section id="Bilder" className='scrollIntoViewFix'><Bilder /></section> */}
      <section id="Programm" className="custom-section-grey scrollIntoViewFix"><Programm2026 /></section>
      <section id="Firmenteilnehmer"><Firmen2026 /></section>      
      <section id="Redaktionen"><Redaktionen2026 /></section>
      <section id="InfosDownloads" className="custom-section-grey"><InfosDownloads /></section>
      <section id="Faq"><FaqSection teilnehmerTyp={props.tlnTyp} /></section>

    </RbsPage>
  )

}

export default Fachpressetage2026;
